<template>
  <v-text-field reverse
            :label="label"
            :outlined="outlined" dense
            v-model="formattedValue"
            :disabled="disabled"
            :readonly="readonly"
            :class="caption?'text-caption':''"
            :hint="hint"
            :persistent-hint="persistentHint"
            :rules="fRules"
            @focus="$event.target.select();focused=true"
            @blur="focused=false;format()"
            @input="$emit('input', valueChanged())"
            @change="$emit('change', valueChanged())"
            :hide-details="hideDetails"
            :prefix="suffix" :suffix="prefix"
            :currency="configuration"/>
</template>

<script>
import { CurrencyDirective, parse } from 'vue-currency-input'

export default {
  name: 'DecimalNumberInput',
  directives: {currency: CurrencyDirective},
  props: {
    value: {type:Number,required:false},
    label: {type:String, required:false},
    prefix: {type:String, required:false, default:"$"},
    suffix: {type:String, required:false, default:""},
    precision: {type:Number, required:false, default:2},
    disabled: {type:Boolean, required:false, default:false},
    readonly: {type:Boolean, required:false, default:false},
    hint: {type:String, required:false},
    persistentHint: {type:Boolean, required:false},
    outlined: {type:Boolean,required:false, default:true},
    rules: {type:Array,required:false, default:() => {return []}},
    hideDetails: {type:Boolean,required:false},
    integer: {type:Boolean,required:false,default:false},
    min: {type:Number, required:false, default:0},
    max: {type:Number, required:false},
    noMinimum: {type:Boolean, required:false, default:false},
    caption: {type:Boolean, required:false, default:false}
  },
  data() {
    return {
      focused: false,
      formattedValue: this.value || ''
    }
  },
  watch: {
    value() {
      if (!this.focused)
        this.format();
    },
    precision() {
      this.format();
    }
  },
  computed: {
    fRules() {
      const rules = [this.internalRules, ...this.rules];
      return rules;
    },
    configuration() {
      const configuration = {precision:this.precision, currency: {prefix:''}, valueAsInteger:this.integer, locale:'en-CA'};
//      const configuration = {precision:this.precision, currency: {prefix:''}, valueAsInteger:this.integer, locale:navigator.languages?.[0] ?? navigator.language};
      return configuration;
    }
  },
  created() {
    this.format();
  },
  methods: {
    format() {
      this.formattedValue = this.$number(this.value, this.precision);
    },
    internalRules(v) {
      let value = 0;
      if (v != '' && v != undefined) {
        if (v.startsWith('.'))
          v = '0' + v;
        value = parse(this.formattedValue, this.configuration) || 0;
      }

      if (!this.noMinimum && this.min !== undefined && value < this.min)
        return `Must be >= ${this.min}`;
      if (this.max !== undefined && value > this.max)
        return `Must be <= ${this.max}`;

      if (this.integer) {  // GraphQL has limit of 32-bit signed integer, so check that
        if (value < -2147483648 || value > 2147483647)
          return 'Out of range';
      }

      return true;
    },

    valueChanged() {
      let value = 0;
      if (this.formattedValue != '' && this.formattedValue != undefined)
        value = parse((this.formattedValue.startsWith('.') ? '0' : '') + this.formattedValue, this.configuration) || 0;
      else
        value = 0;

      return this.$roundNumber(value, this.precision);
    }
  }
}
</script>